class RoutesMap {
    constructor() {
        this.cname = '[data-comp="routes-map"]';
        this.components = document.querySelectorAll(this.cname);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach((component) => {
            this.renderMap(component);

            if (window.innerWidth > 960) {
                this.events(component);
            }
        });
    }

    events(component) {
        let cards = component.querySelectorAll(".card-highlight");
        cards.forEach(card => {
            card.addEventListener("mouseenter", () => {

                this.deactivateMapElements(component);
                this.resetScaleCircles(component);

                
                let ID = card.dataset.id;
                
                if (ID) {
                    this.toggleMapElement(component, ID, true);
                    this.activatePins(component, ID);
                }
                
            });

            card.addEventListener("mouseleave", () => {
                this.deactivateMapElements(component);
                this.resetScaleCircles(component);
            });

        });
    }

    renderMap(component) {
        let image = component.querySelector("[data-comp='map']");
        const imageMobile = component.querySelector("[data-comp='map'].mobile");
        if (window.innerWidth < 960 && imageMobile) {
            image = imageMobile;
        }
        if (image && image.tagName === 'IMG' && image.src) {
            const url = image.src;
            if (url.endsWith('.svg')) {
                this.renderSVG(url)
                    .then((svgElement) => {
                        if (svgElement) {
                            this.updateImageMap(component, svgElement);
                        }
                    })
                    .catch((error) => {
                        console.error('Error al renderizar el SVG:', error);
                    });
            } else {
                this.updateImageMap(component);
            }
        }
    }

    async renderSVG(url) {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Error al obtener el SVG: ${response.statusText}`);
            }

            const svgText = await response.text();
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgElement = svgDoc.documentElement;

            if (svgElement.nodeName === 'svg') {
                return svgElement;
            } else {
                throw new Error('El archivo no contiene un elemento SVG válido.');
            }
        } catch (error) {
            console.error('Error al obtener o parsear el SVG:', error);
        }
        return null;
    }

    updateImageMap(component, svgElement = null) {
        const container = component.querySelector(".col-map");
        if (container) {
            if (svgElement) {
                container.innerHTML = '';
                container.appendChild(svgElement);
            }
            component.classList.add("show");

            this.assignShow(component, svgElement);

            if(window.innerWidth < 960) {
                this.splideMobile(component);
            }

        } else {
            console.warn('No se encontró el contenedor .col-map en el componente:', component);
        }
    }

    assignShow(component, svgElement) {
        const id = component.dataset.mapId;

        if (id) {
            const targetSvgElement = svgElement.querySelector(`#${id}`);

            if (targetSvgElement) {
                targetSvgElement.classList.add('show-text');
            }
        }

    }

    splideMobile(component) {
        let slider = component.querySelector(".splide");
        if (slider) {
            let splide = new Splide(slider, {
                perPage: 1,
                gap: '2rem',
                pagination: false,
                arrows: false,
            });

            splide.on('move', (a, b, c) => {
                this.deactivateMapElements(component);
                let activeSlide = splide.Components.Slides.getAt(a);

                if (activeSlide.slide) {
                    let slideId = activeSlide.slide.dataset.id;
                    if (slideId) {
                        this.toggleMapElement(component, slideId, true);
                    }
                }
            });

            splide.mount();

            let initialSlide = splide.Components.Slides.getAt(0);
            let initialSlideId = initialSlide.slide.dataset.id;

            if (initialSlideId) {
                this.toggleMapElement(component, initialSlideId, true);
            }
        }
    }


    toggleMapElement(component, ID, add = false) {
        let target = component.querySelector(`#${ID}`);
        if (target) {
            target.classList[add ? 'add' : 'remove']("active");
        }
    }

    deactivateMapElements(component) {
        let map = component.querySelector(`.col-map`);
        if (map) {
            map.querySelectorAll(".active").forEach(element => element.classList.remove("active"));
        }
    }

    activatePins(component, ID) {
        let pins = component.querySelector(`#${ID}`);
        let circles = pins = pins.querySelectorAll("circle");

        if (circles.length) {
            for (const circle of circles) {
                circle.setAttribute('r', '6.5');
            }
        }
        
    }
    resetScaleCircles(component) {
        let circles = component.querySelectorAll("svg circle");
        if (circles) {
            for (const circle of circles) {
                circle.setAttribute('r', '4.5');
            }
        }
    }
}

if (document.querySelectorAll('[data-comp="routes-map"]').length) {
    new RoutesMap('[data-comp="routes-map"]');
}
